import { Person } from "../pages/models";
import {
	RestResponse,
	RestService
} from "@sinossi/mates-react-library";

export class PersonService {
	static deletePerson = (id: string, callback: (response: RestResponse<Person, any>) => void) => {
		RestService.delete<Person>(`/api/people/${id}`)
			.then(callback);
	};
}
